import * as React from 'react';
import { Layout } from 'react-admin';
import { useMatch } from 'react-router-dom';
import Menu from './Menu';

export default (props) => {
	const route = useMatch('/printableBusiness');
	const { children } = props;
	if (route) {
		return (
			<div>{children}</div>
		);
	}
	return (<Layout {...props} menu={Menu} />);
};
